import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/layout/App';  // Adjust the path as needed

const root = document.getElementById('root');
const reactRoot = ReactDOM.createRoot(root);

reactRoot.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);